/**
 * Positions <x-tooltip> bubbles. They are position: fixed so that no scrolling
 * or overflow-hidden ancestor (such as the DataTables scroll body) can clip them;
 * show/hide is plain CSS (group-hover), this only writes the coordinates and
 * hides the bubble when the page scrolls under the pointer.
 */
export function initTooltips() {
    let active = null;

    document.addEventListener('mouseover', (event) => {
        const trigger = event.target.closest('.group');
        const tooltip = trigger?.querySelector(':scope > [data-tooltip]');

        if (!tooltip) {
            return;
        }

        const rect = trigger.getBoundingClientRect();
        const fitsAbove = rect.top > 48;

        tooltip.style.left = `${rect.left}px`;
        tooltip.style.top = fitsAbove ? `${rect.top - 4}px` : `${rect.bottom + 4}px`;
        tooltip.style.transform = fitsAbove ? 'translateY(-100%)' : '';
        tooltip.style.opacity = '';
        active = tooltip;
    });

    document.addEventListener('scroll', () => {
        if (active) {
            active.style.opacity = '0';
        }
    }, { capture: true, passive: true });
}
